const getDefaultState = () => {
  return {
    productSpecific: [],
    hasProvInsurance: null
  }
}

const state = getDefaultState()

const getters = {
  getProductSpecific: (state) => {
    return state.productSpecific
  },
  getAddedInsurance: (state) => {
    return state.hasProvInsurance ? state.hasProvInsurance : null
  },
}
const actions = {
  setProductSpecificAction ({ commit }, productSpecific) {
    commit('setProductSpecific', productSpecific)
  },
  resetStateAction ({ commit }) {
    commit('resetState')
  },
  setAddedInsurance ({ commit }, value) {
    commit('hasAddedInsurance', value)
  }
}

const mutations = {
  setProductSpecific (state, productSpecific) {
    state.productSpecific = productSpecific
  },
  resetState (state) {
    Object.assign(state, getDefaultState())
  },
  hasAddedInsurance (state, value) {
    state.hasProvInsurance = value
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}